import * as React from 'react';
import styled from 'styled-components';
import { compose } from '@doltech/utils/lib/compose';
import { withGlobalModalPortal } from '@doltech/ui/lib/hocs/withGlobalModalPortal';
import { useGrammarLessonListingFilter } from '../hooks/useGrammarLessonListingFilter';
import { GrammarLessonListingFilter } from './GrammarLessonListingFilter';
import { GrammarLessonList } from './GrammarLessonList';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { useQuery } from 'react-query';
import {
  getLandingGrammarTheoriesAuthPaged,
} from '../../shared/apis/landing-grammar';
import { LoadingScreen } from '../../home-page/components/LoadingScreen';
import { PaginationPaging } from '@doltech/ui/lib/figma/Pagination/PaginationPaging/PaginationPaging';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { GrammarUrlByTopicType } from '@doltech/domains/grammar/lib/shared/utils/constants';
import { useRouter } from 'next/router';
import { EmptyLesson } from './EmptyLesson';

const TheoryStatusOption = [
  {
    value: 'NOT_STARTED',
    label: 'Chưa đọc',
  },
  {
    value: 'IN_PROGRESS',
    label: 'Đang đọc',
  },
  {
    value: 'COMPLETED',
    label: 'Đã đọc',
  },
];

const Container = styled.div`
  ${verticalSpace(16)};
  padding: 0 16px;

  .pagination {
    justify-content: flex-end;
  }

  ${fromScreen(769)} {
    ${verticalSpace(24)};
  }
`;

const TitleWrapper = styled.div`
  ${verticalSpace(8)};

  ${fromScreen(769)} {
    ${verticalSpace(16)};
  }
`;

interface SectionLessonListingHasAuthorContentProps {
  type?: 'theory' | 'exercise';
  title?: string;
  topicId?: string;
  otherUrlInfo?: any;
  initData?: any;
  topicUrl?: string;
  currentPageIndex?: number;
}

const SectionLessonListingHasAuthorTheoryContent = (props: SectionLessonListingHasAuthorContentProps) => {
  const { title, topicId, otherUrlInfo, initData, topicUrl, currentPageIndex } = props;
  const { filter, filterQuery } = useGrammarLessonListingFilter();
  const { updateFilter, setPage } = filter;
  const router = useRouter();

  const { data, isLoading } = useQuery<any>(
    ['getLandingGrammarTheoriesAuthPaged', filterQuery, topicId],
    () =>
      getLandingGrammarTheoriesAuthPaged({
        ...filterQuery,
        topicId,
      }),
    {
      refetchOnMount: true,
      keepPreviousData: false,
      initialData: initData,
    },
  );

  if (isLoading) {
    return <LoadingScreen/>;
  }

  return (
    <Container className="session-lesson-listing-content">
      <TitleWrapper>
        <ResponsiveTypography.Paragraph variant="semi-bold/32-40" color="gray180">
          {title}
        </ResponsiveTypography.Paragraph>
        <GrammarLessonListingFilter
          options={TheoryStatusOption}
          filterQuery={filterQuery}
          onUpdateFilter={updateFilter}
        />
      </TitleWrapper>
      {data?.content?.length === 0 ? <EmptyLesson/> :
        <GrammarLessonList type="theory" data={data?.content} otherUrlInfo={otherUrlInfo}/>
      }
      {Boolean(data?.totalPages) && (
        <PaginationPaging
          totalPages={data.totalPages}
          currentPageIndex={currentPageIndex}
          onChange={(pageIndex) => {
            router.push({
              pathname: topicUrl,
              query: {
                topic: GrammarUrlByTopicType[topicId],
                page: pageIndex + 1,
              },
            });
            setPage(pageIndex);
          }}
          color="purple"
          hideOnSingle
        />
      )}
    </Container>
  );
};

export const SectionLessonListingHasAuthorTheory = compose(withGlobalModalPortal)(SectionLessonListingHasAuthorTheoryContent);
